

let logoDesk = document.querySelector('.special-line-landing .header__heading-logo.logo-desktop.hide-mobile');
let logoMobile = document.querySelector('.special-line-landing .header__heading-logo.logo-mobile.show-mobile');
if (logoDesk) {
 logoDesk.src = 'https://cdn.shopify.com/s/files/1/0691/5175/2503/files/logo-white.png?v=1713535833'; 
}
if (logoMobile) {
 logoMobile.src = 'https://cdn.shopify.com/s/files/1/0691/5175/2503/files/logo-white.png?v=1713535833'; 
}

/*
function setCookie(cname, cvalue, minutes) {
  const d = new Date();
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
      }
  }
  return false;
}

 if (getCookie('IceBreak') !== 'viewed') {
    

  body.classList.add('viewport-fixed');
  body.classList.add('viewport-blurred');
}


let body = document.querySelector('body');

window.addEventListener('DOMContentLoaded', function() {

  const TWO_PI = Math.PI * 2;
  
  var images = [],
      imageIndex = 0;
  
  var image,
      imageWidth = 1920,
      imageHeight = 1200;
  
  var vertices = [],
      indices = [],
      fragments = [];
  
  var container = document.querySelector('.break-the-ice-animation');
  
  var clickPosition = [imageWidth * 0.5, imageHeight * 0.5];

  
  let iceCards = document.querySelectorAll('.card-wrapper .break-the-ice-animation');
  
  if (getCookie('IceBreakCards') !== 'viewed') {
    iceCards.forEach((c, index) => {
      c.classList.add('click-product-' + index)
      c.addEventListener('click', function() {
        c.classList.add('hide');
        setTimeout(() => {
          c.remove()
        }, 2100)
        setCookie('IceBreakCards', 'viewed');
      })
    })
  } else if (getCookie('IceBreakCards') === 'viewed') {
     iceCards.forEach((c) => {
      c.remove()
    })
  }
  
  
  if (getCookie('IceBreak') !== 'viewed') {
  
    body.classList.add('viewport-fixed');
    body.classList.add('viewport-blurred');

    TweenMax.set(container, {perspective:500});
    var urls = ['https://cdn.shopify.com/s/files/1/0691/5175/2503/files/special-line-ice-bg_f719fda1-f66c-4e0c-a8d3-9f121891b655.jpg?v=1713442336',
                'https://cdn.shopify.com/s/files/1/0691/5175/2503/files/special-line-ice-bg-mobile.jpg?v=1713778290',
                'https://cdn.shopify.com/s/files/1/0691/5175/2503/files/special-line-ice-bg.jpg?v=1713337700'
               ],
        image,
        loaded = 0;
    
    images[0] = image = new Image();
    imagesLoaded();
    
    image.classList.add('click-splash');

    if (window.innerWidth > 749) {
     image.src = urls[0]; 
    }  else if (window.innerWidth > 1921) {
      image.src = url[2];
    } else {
      window.innerWidth
      image.src = urls[1];
    }
    
  
  }
    
  
  function imagesLoaded() {
      placeImage(false);
      triangulate();
  }
  
  function placeImage(transitionIn) {
      image = images[imageIndex];

     if (++imageIndex === images.length) imageIndex = 0;
  
      image.addEventListener('click', imageClickHandler);
      container.appendChild(image);
  
      if (transitionIn !== false) {
          TweenMax.fromTo(image, 0.75, {opacity:0}, {opacity:1, ease:Back.easeOut});
      }
  }
  
  function imageClickHandler(event) {
    
      TweenMax
        .fromTo(document.querySelector('.text-container'), 10, {opacity:1}, {opacity:0, ease:Back.easeOut});
        body.classList.remove('viewport-blurred');
        body.classList.remove('viewport-fixed')
    
      var box = image.getBoundingClientRect(),
          top = box.top,
          left = box.left;
  
      clickPosition[0] = event.clientX - left;
      clickPosition[1] = event.clientY - top;
  
      triangulate();
      shatter();
    
      setCookie('IceBreak', 'viewed');
      
      setTimeout(() => {
        container.remove()
      }, 5000)
  }
  
  function triangulate() {
      var rings = [
              {r:50, c:12},
              {r:150, c:12},
              {r:300, c:12},
              {r:1200, c:12} // very large in case of corner clicks
          ],
          x,
          y,
          centerX = clickPosition[0],
          centerY = clickPosition[1];
  
      vertices.push([centerX, centerY]);
  
      rings.forEach(function(ring) {
          var radius = ring.r,
              count = ring.c,
              variance = radius * 0.25;
  
          for (var i = 0; i < count; i++) {
              x = Math.cos((i / count) * TWO_PI) * radius + centerX + randomRange(-variance, variance);
              y = Math.sin((i / count) * TWO_PI) * radius + centerY + randomRange(-variance, variance);
              vertices.push([x, y]);
          }
      });
  
      vertices.forEach(function(v) {
          v[0] = clamp(v[0], 0, imageWidth);
          v[1] = clamp(v[1], 0, imageHeight);
      });
  
      indices = Delaunay.triangulate(vertices);
  }
  
  function shatter() {
      var p0, p1, p2,
          fragment;
  
      var tl0 = new TimelineMax({onComplete:shatterCompleteHandler});
  
      for (var i = 0; i < indices.length; i += 3) {
          p0 = vertices[indices[i + 0]];
          p1 = vertices[indices[i + 1]];
          p2 = vertices[indices[i + 2]];
  
          fragment = new Fragment(p0, p1, p2);
  
          var dx = fragment.centroid[0] - clickPosition[0],
              dy = fragment.centroid[1] - clickPosition[1],
              d = Math.sqrt(dx * dx + dy * dy),
              rx = 30 * sign(dy),
              ry = 90 * -sign(dx),
              delay = d * 0.003 * randomRange(0.9, 1.1);
          fragment.canvas.style.zIndex = Math.floor(d).toString();
  
          var tl1 = new TimelineMax();
  
          tl1.to(fragment.canvas, 1, {
              z:-500,
              rotationX:rx,
              rotationY:ry,
              ease:Cubic.easeIn
          });
          tl1.to(fragment.canvas, 0.4,{alpha:0}, 0.6);
  
          tl0.insert(tl1, delay);
  
          fragments.push(fragment);
          container.appendChild(fragment.canvas);
      }
  
      container.removeChild(image);
      image.removeEventListener('click', imageClickHandler);
  }
  
  function shatterCompleteHandler() {
      // add pooling?
      fragments.forEach(function(f) {
          container.removeChild(f.canvas);
      });
      fragments.length = 0;
      vertices.length = 0;
      indices.length = 0;
  }
  
  //////////////
  // MATH UTILS
  //////////////
  
  function randomRange(min, max) {
      return min + (max - min) * Math.random();
  }
  
  function clamp(x, min, max) {
      return x < min ? min : (x > max ? max : x);
  }
  
  function sign(x) {
    return x < 0 ? -1 : 1;
    //return x < 0 ? 0 : 0;
  }
  
  //////////////
  // FRAGMENT
  //////////////
  
  Fragment = function(v0, v1, v2) {
      this.v0 = v0;
      this.v1 = v1;
      this.v2 = v2;
  
      this.computeBoundingBox();
      this.computeCentroid();
      this.createCanvas();
      this.clip();
  };
  Fragment.prototype = {
      computeBoundingBox:function() {
          var xMin = Math.min(this.v0[0], this.v1[0], this.v2[0]),
              xMax = Math.max(this.v0[0], this.v1[0], this.v2[0]),
              yMin = Math.min(this.v0[1], this.v1[1], this.v2[1]),
              yMax = Math.max(this.v0[1], this.v1[1], this.v2[1]);
  
          this.box ={
              x:xMin,
              y:yMin,
              w:xMax - xMin,
              h:yMax - yMin
          };
      },
      computeCentroid:function() {
          var x = (this.v0[0] + this.v1[0] + this.v2[0]) / 3,
              y = (this.v0[1] + this.v1[1] + this.v2[1]) / 3;
  
          this.centroid = [x, y];
      },
      createCanvas:function() {
          this.canvas = document.createElement('canvas');
          this.canvas.width = this.box.w;
          this.canvas.height = this.box.h;
          this.canvas.style.width = this.box.w + 'px';
          this.canvas.style.height = this.box.h + 'px';
          this.canvas.style.left = this.box.x + 'px';
          this.canvas.style.top = this.box.y + 'px';
          this.ctx = this.canvas.getContext('2d');
      },
      clip:function() {
          this.ctx.translate(-this.box.x, -this.box.y);
          this.ctx.beginPath();
          this.ctx.moveTo(this.v0[0], this.v0[1]);
          this.ctx.lineTo(this.v1[0], this.v1[1]);
          this.ctx.lineTo(this.v2[0], this.v2[1]);
          this.ctx.closePath();
          this.ctx.clip();
          this.ctx.drawImage(image, 0, 0);
      }
  };
})
*/